module.exports = __webpack_public_path__ + "root-c2082cbd/ac872edf3d4067ce6e96e6792abb6739.svg";